import { useOpalUser } from './useOpalUser';

export const useOptimizelyUser = () => {
  const { opalUser } = useOpalUser();
  const isOptimizelyUser = Boolean(opalUser?.email?.endsWith('@optimizely.com'));

  return {
    isOptimizelyUser,
  };
};
